(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mue-bundle-swatches"] && !Shopify.designMode) return;
  try {
    (() => {
    const source = document.querySelector('template[data-mue-bundle-swatches]');
    if (!source) return;
    const normalize = (value) => value.trim().normalize('NFC').toLocaleLowerCase('fr');
    const colors = new Map(Array.from(source.content.querySelectorAll('[data-mue-color]'), (node) => [normalize(node.dataset.mueColor), node]));
    const entries = new Map();
    const boxes = new Map();
    let scheduled = false;

    function optionsFor(select) {
      if (select.multiple) return null;
      const options = Array.from(select.options).filter((option) => !(option.value === '' && !colors.has(normalize(option.textContent))));
      if (!options.length || options.some((option) => !colors.has(normalize(option.textContent)))) return null;
      return options;
    }

    function remove(select, entry) {
      entry.group.remove();
      select.classList.remove('mue-bundle-color-select');
      entry.field?.classList.remove('mue-bundle-color-field');
      entries.delete(select);
    }

    function sync(select, entry) {
      entry.buttons.forEach((button) => {
        const option = Array.from(select.options).find((item) => item.value === button.dataset.value);
        const disabled = select.disabled || !option || option.disabled || option.hidden || option.parentElement?.disabled === true;
        if (button.disabled !== disabled) button.disabled = disabled;
        const selected = String(select.value === button.dataset.value);
        if (button.getAttribute('aria-checked') !== selected) button.setAttribute('aria-checked', selected);
      });
      const current = entry.buttons.find((button) => !button.disabled && button.getAttribute('aria-checked') === 'true') || entry.buttons.find((button) => !button.disabled);
      entry.buttons.forEach((button) => {
        const index = button === current ? 0 : -1;
        if (button.tabIndex !== index) button.tabIndex = index;
      });
    }

    function choose(select, button) {
      if (button.disabled || !select.isConnected) return;
      if (select.value !== button.dataset.value) {
        const setter = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;
        setter.call(select, button.dataset.value);
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      refresh();
    }

    function enhance(select) {
      const options = optionsFor(select);
      let entry = entries.get(select);
      if (!options) {
        if (entry) remove(select, entry);
        return;
      }
      const signature = JSON.stringify(options.map((option) => [option.value, option.textContent]));
      if (entry && (entry.signature !== signature || !entry.group.isConnected || entry.group.previousElementSibling !== select)) {
        remove(select, entry);
        entry = null;
      }
      if (!entry) {
        const group = document.createElement('div');
        group.className = 'mue-bundle-swatches';
        group.setAttribute('role', 'radiogroup');
        group.setAttribute('aria-label', select.getAttribute('aria-label') || source.dataset.label);
        const buttons = options.map((option) => {
          const swatch = colors.get(normalize(option.textContent));
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'mue-bundle-swatch';
          button.dataset.value = option.value;
          button.setAttribute('role', 'radio');
          button.setAttribute('aria-label', swatch.dataset.mueColor);
          button.title = swatch.dataset.mueColor;
          button.append(swatch.querySelector('.mue-color-dot').cloneNode(true));
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            choose(select, button);
          });
          group.append(button);
          return button;
        });
        group.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          event.stopPropagation();
          const enabled = buttons.filter((button) => !button.disabled);
          if (!enabled.length) return;
          let index = enabled.indexOf(document.activeElement);
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = enabled.length - 1;
          else index = (index + (['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 1) + enabled.length) % enabled.length;
          enabled[index].focus();
          choose(select, enabled[index]);
        });
        const parent = select.parentElement;
        const field = parent !== select.closest('.moonbundle-box') && parent.querySelectorAll('select').length === 1 ? parent : null;
        entry = { group, buttons, signature, field };
        entries.set(select, entry);
        select.after(group);
        select.classList.add('mue-bundle-color-select');
        field?.classList.add('mue-bundle-color-field');
      }
      sync(select, entry);
    }

    function updateCampaignTitle(box) {
      if (!document.body.classList.contains('mue-octobre-rose')) return;
      box.querySelectorAll('.moonbundle-title').forEach((title) => {
        const text = normalize(title.textContent).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        if (text !== 'offre de rentree') return;
        const walker = document.createTreeWalker(title, NodeFilter.SHOW_TEXT);
        let node;
        let replaced = false;
        while ((node = walker.nextNode())) {
          if (!node.nodeValue.trim()) continue;
          node.nodeValue = replaced ? '' : source.dataset.campaignTitle;
          replaced = true;
        }
      });
    }

    function decorateGift(box) {
      const isGiftLabel = (node) => /^[1-9]\d*\s*GRATUITS?$/iu.test(node.textContent.replace(/[\u200B-\u200D\uFEFF]/gu, '').trim());
      box.querySelectorAll('span, div, p, strong, b, small').forEach((node) => {
        const eligible = isGiftLabel(node) && !Array.from(node.children).some(isGiftLabel);
        node.classList.toggle('mue-bundle-gift', eligible);
      });
    }

    function refresh() {
      for (const [select, entry] of entries) {
        if (!select.isConnected || !select.closest('.moonbundle-box')) remove(select, entry);
      }
      for (const [box, observer] of boxes) {
        if (!box.isConnected) {
          observer.disconnect();
          box.removeEventListener('change', schedule);
          boxes.delete(box);
        }
      }
      document.querySelectorAll('.moonbundle-box').forEach((box) => {
        if (!boxes.has(box)) {
          const observer = new MutationObserver(schedule);
          observer.observe(box, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'selected', 'hidden'] });
          box.addEventListener('change', schedule);
          boxes.set(box, observer);
        }
        box.querySelectorAll('select').forEach(enhance);
        decorateGift(box);
        updateCampaignTitle(box);
      });
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        refresh();
      });
    }

    const observer = new MutationObserver((records) => {
      if (records.some((record) => Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some((node) => node.nodeType === 1 && (node.matches('.moonbundle-box') || node.querySelector('.moonbundle-box'))))) schedule();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('pageshow', schedule);
    refresh();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mue-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (function () {
  function addDays(date, days) {
    var result = new Date(date);
    while (days > 0) { result.setUTCDate(result.getUTCDate() + 1); if (result.getUTCDay() !== 0 && result.getUTCDay() !== 6) days--; }
    return result;
  }

  function parisToday(now) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Paris',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(now);
    var values = {};
    parts.forEach(function (part) { values[part.type] = part.value; });
    return new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day), 12));
  }

  function update() {
    var today = parisToday(new Date());
    var range = [addDays(today, 6), addDays(today, 9)];
    var format = new Intl.DateTimeFormat('fr-FR', { timeZone: 'UTC', day: 'numeric', month: 'long' });

    document.querySelectorAll('[data-mue-delivery]').forEach(function (root) {
      var line = root.querySelector('[data-mue-delivery-date]');
      if (line) {
        line.textContent = root.dataset.prefix + ' ' + format.format(range[0]) + ' ' + root.dataset.and + ' ' + format.format(range[1]) + '.';
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
  document.addEventListener('shopify:section:load', update);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mue-fit-system"] && !Shopify.designMode) return;
  try {
    (function () {
  const normalize = value => String(value || '').trim().toUpperCase().replace(/^XXXL$/, '3XL').replace(/^XXL$/, '2XL');
  function profileFor(profile,color) {
    return profile?.color_profiles?.[color] || profile;
  }
  function resolve(product, profile, band, cup, color) {
    profile=profileFor(profile,color);
    if (!profile || profile.kind==='unmapped' || profile.kind==='reference') return {status:'unmapped'};
    if (!band || (profile.kind!=='weight' && !cup) || band === 'other') return {status:'incomplete'};
    const b=Number(band),c=normalize(cup).replace(/^DDD$/,'F').replace(/^DD$/,'E');
    let size,match;
    if(profile.kind==='measurements') {
      const hips=Number(String(cup).replace(',','.'));
      const waist=Number(String(band).replace(',','.'));
      if(!Number.isFinite(waist)||!Number.isFinite(hips)||waist<=0||hips<=0)return {status:'incomplete'};
      const rows=(profile.measurement_rows||[]).filter(row=>waist>=row.waist[0]&&waist<=row.waist[1]&&hips>=row.hips[0]&&hips<=row.hips[1]);
      if(rows.length!==1)return {status:'uncovered'};
      size=rows[0].size;
    } else if(profile.kind==='weight') {
      if(!cup) return {status:'incomplete'};
      if(!profile.cups.includes(c)) return {status:'uncovered'};
      const rows=profile.weight_rows.filter(row=>b>=row.min && b<=row.max);
      if(rows.length!==1) return {status:'uncovered'};
      size=rows[0].size;
    } else if(profile.kind==='direct') {
      if(!profile.bands.includes(b)||!profile.cups.includes(c))return {status:'uncovered'};
      size=`${b}${c}`;
      match=variant=>variant.options[product.options.indexOf('Tour de dos')]===String(b) && variant.options[product.options.indexOf('Bonnet')]===c;
    } else if(profile.kind==='alpha') {
      size=profile.rows[c]?.[profile.bands.indexOf(b)];
      if(!size)return {status:'uncovered'};
    } else return {status:'unmapped'};
    if(!match)match=variant=>normalize(variant.options[product.options.indexOf('Taille')])===normalize(size);
    const variants=product.variants.filter(match);
    if(!variants.length)return {status:'not_sold',size};
    const available=variants.filter(v=>v.available);
    if(!available.length)return {status:'sold_out',size};
    const colorIndex=product.options.findIndex(name=>/couleur|coloris|color/i.test(name));
    const variant=available.find(v=>!color || colorIndex<0 || v.options[colorIndex]===color);
    if(!variant)return {status:'other_color',size,variants:available};
    return {status:'match',size,variant,variants:available};
  }
  function alternatives(catalog,profiles,currentHandle,band,cup,context) {
    const current=profiles[currentHandle];
    if(context!=='FR' && (!current || !['alpha','measurements'].includes(current.kind)))return [];
    const choices=[];
    for(const product of catalog){
      if(product.handle===currentHandle)continue;
      const base=profiles[product.handle];
      if(!base||base.indicative||base.source==='fauve_fallback')continue;
      if(current?.kind==='measurements'){
        if(base.kind!=='measurements'||base.measurement_family!==current.measurement_family)continue;
      }else if(base.kind!=='alpha')continue;
      const colorIndex=product.options.findIndex(name=>/couleur|coloris|color/i.test(name));
      const colors=colorIndex<0?[undefined]:[...new Set(product.variants.filter(v=>v.available).map(v=>v.options[colorIndex]))];
      for(const color of colors){
        const result=resolve(product,base,band,cup,color);
        if(result.status==='match'){choices.push({product,result});break;}
      }
      if(choices.length===3)break;
    }
    return choices;
  }
  window.MueSizingEngine = {normalize,resolve,alternatives,profileFor};
})();

(function () {
  const initialized = new WeakSet();
  let state = {band:'',cup:''}, alternativeState = {band:'',cup:''}, data, lastOpener;
  const E = window.MueSizingEngine;
  const text = (key, values={}) => Object.entries(values).reduce((s,[k,v])=>s.replaceAll(`{${k}}`,String(v)),data.messages[key]||'');
  function element(tag, value, className) {
    const e=document.createElement(tag);
    if (value!==undefined) e.textContent=value;
    if (className) e.className=className;
    return e;
  }
  function pickerFor(widget) {
    return Array.from(document.querySelectorAll('variant-picker')).find(p=>p.dataset.productId===widget.dataset.productId && !p.closest('quick-add-dialog,product-card'));
  }
  function studioFor(widget) {
    const studio=widget.closest('mue-product-studio');
    return studio?.querySelector('[data-bundle-preview]') ? studio : null;
  }
  function studioPanel(studio) {
    return studio?.querySelector('[data-bundle-panel]:not([hidden])');
  }
  function colorFor(widget) {
    const studio=studioFor(widget);
    if(studio) return studioPanel(studio)?.querySelector('[data-bundle-colour]')?.selectedOptions[0]?.dataset.productValue || studio.querySelector('[data-colour-name]:checked')?.dataset.colourName;
    const picker=pickerFor(widget);
    return Array.from(picker?.querySelectorAll('input:checked')||[]).find(i=>/couleur|coloris|color/i.test(i.dataset.optionName||''))?.value;
  }
  function makeLink(product, variant, label, frenchSize) {
    const a=element('a',label), url=new URL(product.url,location.origin);
    url.searchParams.set('variant',String(variant.id));
    const measurements = frenchSize || (data.profiles[data.current.handle]?.kind==='alpha' ? state : null);
    if (measurements?.band && measurements?.cup && data.profiles[product.handle]?.kind!=='direct') url.hash='repere-'+measurements.band+measurements.cup;
    const preview=new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id',preview);
    a.href=url.pathname+url.search+url.hash;
    return a;
  }
  function frenchAlternatives(widget,box) {
    box.append(element('strong',text('alternatives')));
    const fields=element('fieldset',undefined,'mue-tsimple__alternative-fields');
    fields.append(element('legend',text('alternative_fr')));
    const controls=element('div',undefined,'mue-tsimple__alternative-controls');
    const selectors={};
    [['band','[data-mue-dos]','band'],['cup','[data-mue-bonnet]','cup']].forEach(([key,source,label])=>{
      const wrapper=element('label',undefined,'mue-tsimple__champ');
      wrapper.append(element('span',text(label)));
      const select=element('select');
      Array.from(widget.querySelector(source).options).filter(option=>option.value!=='other').forEach(option=>select.append(option.cloneNode(true)));
      select.value=alternativeState[key];
      select.dataset.mueAlternative=key;
      wrapper.append(select);controls.append(wrapper);selectors[key]=select;
    });
    fields.append(controls);box.append(fields);
    const results=element('div');results.setAttribute('aria-live','polite');box.append(results);
    function update() {
      alternativeState={band:selectors.band.value,cup:selectors.cup.value};
      results.replaceChildren();
      if(!alternativeState.band || !alternativeState.cup) return;
      const choices=E.alternatives(data.catalog,data.profiles,data.current.handle,alternativeState.band,alternativeState.cup,'FR');
      const list=element('ul');
      choices.forEach(({product,result})=>{
        const li=element('li'),a=makeLink(product,result.variant,`${product.title} · ${result.size}`,alternativeState);
        if(product.image){const img=element('img');img.src=product.image;img.alt='';img.width=48;img.height=60;img.loading='lazy';a.prepend(img);}
        li.append(a);list.append(li);
      });
      if(choices.length) results.append(list);
      else {
        results.append(element('p',text('no_alternative')));
        const contact=element('a',text('contact'));contact.href='/pages/contact';results.append(contact);
      }
    }
    Object.values(selectors).forEach(select=>select.addEventListener('change',update));
    update();
  }
  function showAlternatives(widget,result) {
    const box=widget.querySelector('[data-mue-alternatives]');
    box.replaceChildren();
    
    box.hidden=['match','incomplete','unmapped'].includes(result.status);
    if (box.hidden) return;

    const list=element('ul');
    if (result.status==='other_color') {
      const index=data.current.options.findIndex(n=>/couleur|coloris|color/i.test(n));
      const colors=new Set();
      result.variants.forEach(v=>{
        const color=v.options[index];
        if (colors.has(color)) return;
        colors.add(color);
        const li=element('li'); li.append(makeLink(data.current,v,`${color} · ${result.size}`)); list.append(li);
      });
    }
    const choices=E.alternatives(data.catalog,data.profiles,data.current.handle,state.band,state.cup);
    if (choices.length) {
      box.append(element('strong',text('alternatives')));
      choices.forEach(({product,result:r})=>{
        const li=element('li'),a=makeLink(product,r.variant,`${product.title} · ${r.size}`);
        if(product.image){const img=element('img');img.src=product.image;img.alt='';img.width=48;img.height=60;img.loading='lazy';a.prepend(img);}
        li.append(a);list.append(li);
      });
    }
    if (list.childElementCount) box.append(list);
    if (!choices.length && result.status!=='other_color') box.append(element('p',text('no_alternative')));
    if(!list.childElementCount){const contact=element('a',text('contact'));contact.href='/pages/contact';box.append(contact);}
  }
  let selecting=0;
  async function syncBundleSizes(result, token) {
    const setter=Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype,'value').set;
    // Subsequent bundle rows have no label. Identify their option by its values.
    const fields=()=>Array.from(document.querySelectorAll('#MainContent .moonbundle-box .moonbundle-option-selector select')).flatMap(select=>{
      const values=Array.from(select.options).map(option=>option.value).filter(Boolean);
      const index=data.current.options.findIndex((name,index)=>
        !/couleur|coloris|color/i.test(name) && values.length &&
        values.every(value=>data.current.variants.some(variant=>variant.options[index]===value)));
      const value=result.variant.options[index];
      return index>=0 && !select.disabled && Array.from(select.options).some(option=>option.value===value&&!option.disabled) ? [{select,value}] : [];
    });
    for(let pass=0;pass<32;pass++) {
      if(token!==selecting)return false;
      const pending=fields().find(({select,value})=>select.value!==value);
      if(!pending)return true;
      setter.call(pending.select,pending.value);
      pending.select.dispatchEvent(new Event('input',{bubbles:true}));
      pending.select.dispatchEvent(new Event('change',{bubbles:true}));
      await new Promise(requestAnimationFrame);
    }
    return fields().every(({select,value})=>select.value===value);
  }
  async function selectVariant(widget,result) {
    const token=++selecting;
    try {
      const studio=studioFor(widget);
      if(studio){
        const panel=studioPanel(studio);
        if(!panel || result.status!=='match')return false;
        let changed=false;
        panel.querySelectorAll('[data-bundle-size]').forEach(select=>{
          if(select.disabled || select.value===result.size || !Array.from(select.options).some(option=>option.value===result.size && !option.disabled))return;
          select.value=result.size;
          select.dispatchEvent(new Event('change',{bubbles:true}));
          changed=true;
        });
        return changed;
      }
      await Promise.race([customElements.whenDefined('variant-picker'),new Promise((_,reject)=>setTimeout(()=>reject(new Error('picker unavailable')),3000))]);
      if (token!==selecting || !widget.isConnected) return false;
      const picker=pickerFor(widget);
      if (!picker || typeof picker.updateSelectedOption!=='function') return false;
      const inputs=[];
      for (let i=0;i<data.current.options.length;i++) {
        const name=data.current.options[i],value=result.variant.options[i];
        const input=Array.from(picker.querySelectorAll('input[type="radio"]')).find(input=>input.dataset.optionName===name && input.value===value);
        if (!input) {
          if (new Set(data.current.variants.map(v=>v.options[i])).size===1) continue;
          return false;
        }
        inputs.push(input);
      }
      const changed=inputs.filter(input=>!input.checked);
      changed.forEach(input=>picker.updateSelectedOption(input));
      const last=changed.at(-1);
      if (last) {
        last.dataset.variantId=String(result.variant.id);
        last.dispatchEvent(new Event('change',{bubbles:true}));
      }
      await new Promise(resolve=>setTimeout(resolve,120));
      return await syncBundleSizes(result,token);
    } catch (_) { return false; }
  }
  function trackFitResult(widget,result,band,cup) {
    if (!band || !cup || band === 'other' || !result || result.status === 'incomplete') return;

    const color=colorFor(widget)||'';
    const recommended=result.size||'';
    const request=String(band)+String(cup);
    const variantId=result.variant?.id ? String(result.variant.id) : '';
    const availability={
      match:'available',
      other_color:'available_other_color',
      sold_out:'sold_out',
      not_sold:'not_sold',
      uncovered:'outside_range',
      unmapped:'unmapped'
    }[result.status] || result.status;

    const dedupe=[data.current.handle,request,color,result.status,recommended,variantId].join('|');
    if (widget.dataset.mueLastTracked === dedupe) return;
    widget.dataset.mueLastTracked=dedupe;

    const props={
      product_handle:data.current.handle,
      product_title:data.current.title||'',
      requested_size:request,
      requested_band:String(band),
      requested_cup:String(cup),
      recommended_size:recommended || 'none',
      status:result.status,
      availability:availability,
      selected_color:color,
      variant_id:variantId,
      page_path:location.pathname
    };

    // Clarity: tags make the matching recordings directly filterable.
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('set','mue_fit_product',props.product_handle);
        window.clarity('set','mue_fit_requested_size',props.requested_size);
        window.clarity('set','mue_fit_recommended_size',props.recommended_size);
        window.clarity('set','mue_fit_status',props.status);
        window.clarity('set','mue_fit_availability',props.availability);
        window.clarity('event','mue_fit_completed');
        if (props.status !== 'match') window.clarity('event','mue_fit_attention');
      }
    } catch (_) {}

    // Klaviyo client Events API: direct browser-side event delivery.
    // Respect Shopify's consent state; do not send analytics when not allowed.
    try {
      const privacy=window.Shopify?.customerPrivacy;
      if (privacy && typeof privacy.analyticsProcessingAllowed === 'function' && !privacy.analyticsProcessingAllowed()) return;

      let anon='';
      try {
        anon=localStorage.getItem('mue.fit.anon')||'';
        if (!anon) {
          anon=(crypto.randomUUID ? crypto.randomUUID() : 'mue-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2));
          localStorage.setItem('mue.fit.anon',anon);
        }
      } catch (_) {
        window.__mueFitAnon=window.__mueFitAnon || ('mue-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2));
        anon=window.__mueFitAnon;
      }

      const payload={
        data:{
          type:'event',
          attributes:{
            metric:{data:{type:'metric',attributes:{name:'MUE - Taille calculée'}}},
            profile:{data:{type:'profile',attributes:{anonymous_id:anon}}},
            properties:{...props,tracking_version:'direct-v2'},
            time:new Date().toISOString()
          }
        }
      };

      fetch('https://a.klaviyo.com/client/events/?company_id=VWz6NE',{
        method:'POST',
        headers:{
          'accept':'application/vnd.api+json',
          'content-type':'application/vnd.api+json',
          'revision':'2026-07-15'
        },
        body:JSON.stringify(payload),
        keepalive:true
      }).catch(()=>{});
    } catch (_) {}
  }

  function renderWidget(widget,select=false) {
    const dos=widget.querySelector('[data-mue-dos]'),cup=widget.querySelector('[data-mue-bonnet]');
    if (!dos || !cup) return;
    const studio=studioFor(widget);
    const profile=E.profileFor(data.profiles[data.current.handle],colorFor(widget));
    const result=E.resolve(data.current,profile,dos.value,cup.value,colorFor(widget),data.profiles.__common);
    if(!studio && profile?.kind!=='weight' && profile?.kind!=='measurements')trackFitResult(widget,result,dos.value,cup.value);
    const output=widget.querySelector('[data-mue-res]'),note=widget.querySelector('[data-mue-note]');
    output.textContent=['match','sold_out','other_color'].includes(result.status)?result.size:'—';
    output.toggleAttribute('data-vide',output.textContent==='—');
    const key={incomplete:'choose',unmapped:'missing',uncovered:'unknown',not_sold:'not_sold',sold_out:'sold_out',other_color:'other_color',match:'success'}[result.status];
    note.textContent=studio && ['match','sold_out','other_color'].includes(result.status) ? text('success',{size:result.size}) : profile?.kind==='weight' && result.status==='incomplete' ? text('choose_weight') : result.status==='unmapped' && profile?.note ? profile.note : text(key,{size:result.size});
    if(profile?.kind==='measurements' && result.status==='incomplete')note.textContent=profile.choose_message;
    if(profile?.indicative && result.status!=='incomplete')note.textContent+=' '+profile.note;
    showAlternatives(widget,result);
    if (select && result.status==='match') {
      const band=dos.value,bonnet=cup.value;
      selectVariant(widget,result).then(ok=>{
        if (!studio && widget.isConnected && dos.value===band && cup.value===bonnet) note.textContent=text(ok?'selected':'selection_failed',{size:result.size})+(profile?.indicative?' '+profile.note:'');
      });
    } else if(select) selecting++;
    highlight();
  }
  function highlight() {
    document.querySelectorAll('.mue-fit-table td').forEach(td=>td.toggleAttribute('data-active',td.dataset.band===state.band && td.dataset.cup===state.cup));
  }
  function choose(band,cup) {
    state={band:String(band),cup};
    document.querySelectorAll('[data-mue-fit-widget]').forEach(widget=>{
      widget.querySelector('[data-mue-dos]').value=state.band;
      widget.querySelector('[data-mue-bonnet]').value=state.cup;
      renderWidget(widget,true);
    });
    highlight();
  }
  function guide() {
    const box=document.querySelector('[data-mue-guide-table]');
    if(!box)return;
    const widget=document.querySelector('[data-mue-fit-widget]');
    const color=widget?colorFor(widget):undefined;
    const profile=E.profileFor(data.profiles[data.current.handle],color);
    const help=document.querySelector('[data-mue-guide-help]');
    const sizes=document.querySelector('[data-mue-guide-sizes]');
    box.replaceChildren();sizes.textContent='';
    if(!profile || profile.kind==='unmapped'){help.textContent=profile?.note || text('unknown_guide');box.append(element('p',help.textContent));return;}
    help.textContent=profile.note || (profile.labels_only?text('direct_help'):'');
    const scroll=element('div',undefined,'mue-fit-scroll');
    const table=element('table',undefined,'mue-fit-table');
    table.append(element('caption',profile.note || text('table_caption')));
    if(profile.table){
      const head=element('thead'),tr=element('tr');
      profile.headings.forEach(label=>{const th=element('th',label);th.scope='col';tr.append(th);});head.append(tr);table.append(head);
      const body=element('tbody');profile.table.forEach(values=>{const row=element('tr');row.dataset.mueSize=E.normalize(values[0]);values.forEach((value,i)=>{const cell=element(i?'td':'th',value);if(!i)cell.scope='row';row.append(cell);});body.append(row);});
      table.append(body);scroll.append(table);box.append(scroll);return;
    }
    const cups=profile.cups || Object.keys(profile.rows || {}),bands=profile.bands || [];
    table.style.setProperty('--mue-fit-columns',String(bands.length));
    const head=element('thead'),tr=element('tr'),corner=element('th');corner.scope='col';corner.append(element('span',text('corner_band'),'mue-fit-corner'),element('span',text('corner_cup'),'mue-fit-corner'));tr.append(corner);
    bands.forEach(band=>{const th=element('th',band);th.scope='col';tr.append(th);});head.append(tr);table.append(head);
    const tones={XS:'#eee5dc',S:'#d4dfcf',M:'#cbddea',L:'#dad4e6',XL:'#edd7df','2XL':'#f2e3c5','3XL':'#e9ebc5','4XL':'#c6b28c','5XL':'#c0a396','6XL':'#af9997'};
    const body=element('tbody');
    cups.forEach(cup=>{const row=element('tr'),th=element('th',cup);th.scope='row';row.append(th);
      bands.forEach((band,index)=>{const td=element('td');td.dataset.band=String(band);td.dataset.cup=cup;
        const mapped=profile.kind==='direct'?`${band}${cup}`:profile.rows[cup]?.[index];
        if(mapped){td.style.setProperty('--mue-size-color',tones[mapped]||'#efe5da');const result=E.resolve(data.current,profile,band,cup,color);
          if(result.status==='match'){const button=element('button',mapped);button.type='button';button.setAttribute('aria-label',text('use_size',{size:mapped})+` · ${band}${cup}`);button.addEventListener('click',()=>{choose(band,cup);closeGuide();});td.append(button);}
          else if(result.status==='not_sold'){td.textContent='—';td.dataset.empty='';}else td.textContent=mapped;
        }else{td.textContent='—';td.dataset.empty='';}row.append(td);
      });body.append(row);
    });table.append(body);scroll.append(table);box.append(scroll);box.append(element('p',text(profile.source==='user_reference_atelier_menara_2026_10_15'?'guide_intro':'stock_note'),'mue-fit-stock'));highlight();
  }
  function configureWidget(widget) {
    const profile=E.profileFor(data.profiles[data.current.handle],colorFor(widget));
    const mode=profile?.kind || 'unmapped';
    const fallbackNote=widget.querySelector('[data-mue-fauve-reference]');
    if(fallbackNote) fallbackNote.hidden=profile?.source!=='fauve_fallback';
    const line=widget.querySelector('.mue-tsimple__ligne');
    line.hidden=['reference','unmapped','bottom'].includes(mode);
    const input=widget.querySelector('[data-mue-dos]');let cup=widget.querySelector('[data-mue-bonnet]');
    if(mode==='measurements'){
      if(widget.dataset.mueProfile==='measurements')return;
      widget.dataset.mueProfile='measurements';
      const fields=[input,cup].map((old,i)=>{
        const field=element('input');field.type='number';field.min='1';field.max='250';field.step='0.1';field.inputMode='decimal';
        field.placeholder=profile.input_labels[i];field.setAttribute('aria-label',profile.input_labels[i]);
        field.dataset[i?'mueBonnet':'mueDos']='';
        const label=old.closest('label')?.querySelector('span');if(label)label.textContent=profile.input_labels[i];
        old.replaceWith(field);return field;
      });
      fields.forEach(field=>field.addEventListener('change',()=>{state={band:fields[0].value,cup:fields[1].value};renderWidget(widget,true);}));
      return;
    }
    const signature=mode+'|'+(profile?.source_sku||'');
    if(widget.dataset.mueProfile===signature)return;
    widget.dataset.mueProfile=signature;
    const label=widget.querySelector('[data-mue-band-label]');
    if(mode==='weight'){
      const field=element('input');field.type='number';field.min='45';field.max='112';field.step='0.1';field.inputMode='decimal';field.dataset.mueDos='';field.placeholder=text('weight');field.setAttribute('aria-label',text('weight'));input.replaceWith(field);label.textContent=text('weight');
    }else{
      const field=element('select');field.dataset.mueDos='';field.setAttribute('aria-label',text(profile?.labels_only?'band_label':'band'));
      const empty=element('option',text('band_short'));empty.value='';field.append(empty);
      (mode==='alpha'?[...new Set([80,85,90,95,100,105,110,115,120,125,...(profile?.bands||[])])].sort((a,b)=>a-b):profile?.bands||[]).forEach(b=>{const option=element('option',b);option.value=String(b);field.append(option);});
      input.replaceWith(field);label.textContent=text(profile?.labels_only?'band_label':'band');
    }
    const newCup=element('select');newCup.dataset.mueBonnet='';cup.replaceWith(newCup);cup=newCup;
    cup.replaceChildren();const emptyCup=element('option',text('cup'));emptyCup.value='';cup.append(emptyCup);
    (['weight','alpha'].includes(mode)?['A','B','C','D','E','F','G','H','I']:profile?.cups||[]).forEach(c=>{const option=element('option',c);option.value=c;cup.append(option);});
    const dos=widget.querySelector('[data-mue-dos]');dos.value=state.band;cup.value=state.cup;
    [dos,cup].forEach(field=>field.addEventListener('change',()=>{state={band:dos.value,cup:cup.value};renderWidget(widget,true);}));
  }
  function syncColorGuides() {
    const widget=document.querySelector('[data-mue-fit-widget]');if(!widget)return;
    const color=colorFor(widget),profile=data.profiles[data.current.handle];
    document.querySelectorAll('[data-mue-profile-color]').forEach(box=>box.hidden=box.dataset.mueProfileColor!==color);
    document.querySelectorAll('[data-mue-profile-default]').forEach(box=>box.hidden=!!profile?.color_profiles?.[color]);
  }
  function closeGuide() {
    document.getElementById('mue-guide-tailles')?.close();
    lastOpener?.focus({preventScroll:true});
  }
  function initialize() {
    document.querySelectorAll('[data-mue-fit-widget]').forEach(widget=>{if(initialized.has(widget))return;initialized.add(widget);configureWidget(widget);renderWidget(widget);});
    syncColorGuides();
  }
  function boot() {
    const source=document.getElementById('mue-fit-data');
    if (!source) return;
    try {data=JSON.parse(source.textContent);}catch(_){return;}
    for(const product of [data.current,...data.catalog]) {
      if(product.profile)data.profiles[product.handle]=product.profile;
      product.variants=product.ids.map((id,index)=>({id,available:product.available[index],options:product.options.map((_,optionIndex)=>product['option'+(optionIndex+1)][index])}));
    }
    const remembered=location.hash.match(/^#repere-(\d{2,3})([A-I])$/);
    if(remembered && data.profiles[data.current.handle]?.kind!=='direct')state={band:remembered[1],cup:remembered[2]};
    initialize();guide();
    document.addEventListener('click',event=>{
      const target=event.target.closest('[data-mue-guide],a[href*="guide-des-tailles"],a[href="#mue-guide-tailles"]');
      if (target) {
        const dialog=document.getElementById('mue-guide-tailles');
        if(dialog?.showModal){event.preventDefault();lastOpener=target;guide();dialog.showModal();}
      }
      if (event.target.closest('[data-mue-guide-fermer]')) closeGuide();
    });
    const dialog=document.getElementById('mue-guide-tailles');
    dialog?.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)closeGuide();}});
    document.addEventListener('change',event=>{
      if(event.target.closest('variant-picker') && /couleur|coloris|color/i.test(event.target.dataset.optionName||'')){document.querySelectorAll('[data-mue-fit-widget]').forEach(widget=>{configureWidget(widget);renderWidget(widget);});syncColorGuides();guide();}
      if(event.target.matches('[data-bundle-colour], [data-bundle-formula], [data-colour-name]')){
        document.querySelectorAll('[data-mue-fit-widget]').forEach(widget=>{if(studioFor(widget)){configureWidget(widget);renderWidget(widget);}});syncColorGuides();guide();
      }
    });
    document.addEventListener('shopify:section:load',initialize);
    const main=document.getElementById('MainContent');
    if(main)new MutationObserver(changes=>{if(changes.some(c=>Array.from(c.addedNodes).some(n=>n.nodeType===1 && (n.matches?.('[data-mue-fit-widget]')||n.querySelector?.('[data-mue-fit-widget]')))))initialize();}).observe(main,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mue-inline-video-rail"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mue-inline-video-rail')) {
    customElements.define('mue-inline-video-rail', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        this.boundVideos = new WeakSet();
        const options = { signal: this.events.signal };
        this.rail = this.querySelector('[data-inline-video-rail]');
        this.cards = [...this.querySelectorAll('[data-inline-video-card]')];
        if (!this.rail) return;
        this.mobileViewport = window.matchMedia('(max-width: 989px)');
        // Évite le voile sombre des commandes vidéo natives sur iOS.
        // Tant que le JS n'est pas prêt, les contrôles natifs restent utilisables.
        this.cards.forEach(card => {
          const video = card.querySelector('.mue-inline-videos__video--mobile-native');
          const toggle = card.querySelector('[data-inline-mobile-toggle]');
          if (!video || !toggle) return;
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
          video.controls = false;
          video.removeAttribute('controls');
          const update = () => {
            const playing = !video.paused && !video.ended;
            toggle.dataset.playing = String(playing);
            toggle.setAttribute('aria-pressed', String(playing));
            toggle.setAttribute('aria-label', playing ? toggle.dataset.labelPause : toggle.dataset.labelPlay);
          };
          const fallback = () => {
            if (!this.isConnected || options.signal.aborted) return;
            video.controls = true;
            video.style.pointerEvents = 'auto';
            toggle.hidden = true;
            const status = card.querySelector('[data-inline-video-status]');
            if (status) { status.textContent = this.dataset.videoError; status.hidden = false; }
          };
          ['play', 'pause', 'ended'].forEach(type => video.addEventListener(type, update, options));
          video.addEventListener('error', fallback, options);
          toggle.addEventListener('click', (event) => {
            event.preventDefault();
            if (!video.paused && !video.ended) {
              video.pause();
            } else {
              if (video.ended) video.currentTime = 0;
              video.play().catch(fallback);
            }
          }, options);
          update();
        });
        this.classList.add('mue-inline-videos--enhanced');
        // Un tap sur l'image démarre ou suspend la lecture ; le swipe reste libre.
        this.addEventListener('click', (event) => {
          if (!this.mobileViewport.matches || event.target.closest('[data-inline-mobile-toggle]')) return;
          const frame = event.target.closest('[data-inline-video-frame]');
          if (frame && this.contains(frame)) frame.querySelector('[data-inline-mobile-toggle]')?.click();
        }, options);
        this.addEventListener('click', (event) => {
          const start = event.target.closest('[data-inline-video-start]');
          if (!start || !this.contains(start)) return;
          const card = start.closest('[data-inline-video-card]');
          const frame = card.querySelector('[data-inline-video-frame]');
          const template = frame.querySelector('[data-inline-video-template]');
          if (!template) return;
          let video = frame.querySelector('video:not(.mue-inline-videos__video--mobile-native)');
          if (!video) {
            frame.append(template.content.cloneNode(true));
            video = frame.querySelector('video:not(.mue-inline-videos__video--mobile-native)');
          }
          if (!video) return;
          const status = card.querySelector('[data-inline-video-status]');
          start.hidden = true;
          status.hidden = true;
          video.muted = true;
          video.defaultMuted = true;
          const reportError = (error) => {
            if (!this.isConnected || options.signal.aborted || error?.name === 'AbortError') return;
            start.hidden = false;
            status.textContent = this.dataset.videoError;
            status.hidden = false;
          };
          if (!this.boundVideos.has(video)) {
            this.boundVideos.add(video);
            video.addEventListener('error', reportError, options);
            video.addEventListener('playing', () => { status.hidden = true; }, options);
          }
          if (video.error) video.load();
          video.focus({ preventScroll: true });
          video.play().catch(reportError);
        }, options);
        document.addEventListener('play', (event) => {
          if (!(event.target instanceof HTMLVideoElement) || !event.target.closest('mue-inline-video-rail, mue-product-proof, mue-detail-video')) return;
          document.querySelectorAll('mue-inline-video-rail video, mue-product-proof video, mue-detail-video video').forEach((video) => {
            if (video !== event.target) video.pause();
          });
        }, { capture: true, signal: this.events.signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.querySelectorAll('video').forEach((video) => video.pause());
        }, options);
        this.observer?.disconnect();
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) entry.target.querySelectorAll('video').forEach(video => video.pause());
          });
        }, { root: this.rail, threshold: 0.25 });
        this.cards.forEach(card => this.observer.observe(card));
      }
      disconnectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
        this.querySelectorAll('video').forEach((video) => video.pause());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
